export const header: HeaderSetup = {
    background: 'linear-gradient(137deg, #FFF 260px, transparent 260px), #ffe6b4',
    backgroundMobile: '#ffe6b4',
    foreground: null,
    logo: '/assets/kromatic-black.svg',
    logoLink: null,
    logoMobile: '/favicon.png',
    tagline: 'Yes Chef! How to Predict Revenue Under Uncertainty',
    textOffset: 115,
    title: 'Innovation Accounting Simulation',
};
